"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypedInput = TypedInput;

var _react = _interopRequireDefault(require("react"));

var _toArray = _interopRequireDefault(require("lodash/toArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Types = require("./Types");

var _TextBasedInput = _interopRequireDefault(require("./TextBasedInput"));

var _BooleanInput = _interopRequireDefault(require("./BooleanInput"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function TypedInput(props) {
  return props.type === _Types.Types.Boolean ? /*#__PURE__*/_react["default"].createElement(_BooleanInput["default"], props) : /*#__PURE__*/_react["default"].createElement(_TextBasedInput["default"], props);
}

TypedInput.propTypes = {
  type: _propTypes["default"].oneOf((0, _toArray["default"])(_Types.Types))
};
TypedInput.defaultProps = {
  type: _Types.Types.String
};